import { createApp } from './main'
import { initConfig } from '@nmp-js/huck/client'
import { trackPageView, setState } from '@finn-no/pulse-sdk'

const appEl = '#pf-fp-spa'
setState({ vertical: { name: 'personal_finance' } })
initConfig(appEl)


const { app, router } = createApp()

router.isReady().then(() => {
  app.mount(appEl)
})

router.afterEach((to, from) => {
  document.title = to.meta.title
  const metaDesc = document.querySelector('meta[name=description]') || {}
  metaDesc.content = to.meta.description
  const canonicalEl = document.querySelector('link[rel=canonical]') || {}
  canonicalEl.href = window.location.href

  const origin = from.href ? { url: window.location.origin + from.href } : {}
  trackPageView({
    origin,
    object: { type: 'MarketFrontpage' },
    vertical: { name: 'personal_finance' }
  })
})
